import gql from 'graphql-tag'

export const countriesQuery = gql`
  query getCountries {
    countries: getCountries {
      name: countryName
      code: countryCode
      geonameId
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ShippingAddressForm/data.ts